import { createFileRoute } from '@tanstack/react-router';
import { settingsRouteOptions } from '../-workspaceRouteOptions';

export const Route = createFileRoute('/_authed/$orgSlug/settings')({
  ...settingsRouteOptions,
});
